<template>
  <div>
    <section class="content">
      <div class="col-md-12">
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Inscription des membres en ligne</span>
                <span class="caption-helper"></span>
              </div>
              <div class="subsubject">
                {{stepText}}
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <div role="tablist">
              <b-collapse visible class="mt-2" v-model="showCollapse1" id="collapse1">
                <b-card>
                  <div class="card-text" style="font-weight: 400;">
                    <div class="form-group">
                      <div class="radio">
                        <label>
                          <input type="radio"
                                 value="new"
                                 v-model="choixInscription"
                                 checked="">
                          Nouveau membre
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio"
                                 v-model="choixInscription"
                                 value="renew">
                          Renouvellement
                        </label>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-collapse>
              <b-collapse class="mt-2" v-model="showCollapse2" id="collapse2">
                <b-card>
                  <div class="row" v-if="choixInscription=='new'">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nom">Nom:</label>
                        <input class="form-control" type="text" v-model="newMembre.nom" id="nom">
                      </div>
                      <div class="form-group">
                        <label for="nom">Prénom:</label>
                        <input class="form-control" type="text" v-model="newMembre.prenom" id="prenom">
                      </div>
                      <div class="form-group">
                        <label for="nom">Sexe:</label>
                        <div class="radio">
                          <label class="checkbox-inline">
                            <input type="radio"
                                   value="1"
                                   v-model="newMembre.sexe"
                                   checked="">
                            Masculin
                          </label>
                        </div>
                        <div class="radio">
                          <label class="checkbox-inline">
                            <input type="radio"
                                   v-model="newMembre.sexe"
                                   value="0">
                            Féminin
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dob">Date de naissance:</label>
                        <input class="form-control" type="text" v-model="newMembre.prenom" id="dob">
                      </div>

                      <div class="form-group">
                        <label for="adresse">Adresse:</label>
                        <input class="form-control" type="text" v-model="newMembre.adresse" id="adresse">
                      </div>

                      <div class="form-group">
                        <label for="cp">Code postal:</label>
                        <input class="form-control" type="text" v-model="newMembre.cp" id="cp">
                      </div>

                      <div class="form-group">
                        <label for="nom">Ville:</label>
                        <input class="form-control" type="text" v-model="newMembre.ville" id="ville">
                      </div>

                      <div class="form-group">
                        <label for="tel">Téléphone / GSM:</label>
                        <input class="form-control" type="text" v-model="newMembre.telephone_gsm" id="tel">
                      </div>

                      <div class="form-group">
                        <label for="mail">Mail:</label>
                        <input class="form-control" type="text" v-model="newMembre.mail" id="mail">
                      </div>

                      <div class="form-group">
                        <a class="btn btn-default pull-left" @click.prevent="choixInscription=null"> < Retour</a>
                      </div>

                    </div>
                  </div>

                  <div class="row" v-if="choixInscription=='renew'">
                    <div class="col-md-4">
                      <vue-simple-spinner
                        :size="64"
                        message="Recherche en cours..."
                        :spacing="25"
                        text-fg-color="#FFF"
                        :font-size="16"
                        v-if="rechercheEnCours"
                      ></vue-simple-spinner>
                      <div v-if="!rechercheEnCours">

                        <div class="form-group">
                          <label for="dob">Date de naissance:</label>
                          <masked-input type="text"
                                        v-model="searchMembre.date_naissance"
                                        v-validate="'date_format:DD/MM/YYYY'"
                                        :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                        :guide="true"
                                        :keepCharPositions="true"
                                        :showMask="true"
                                        name="date_naissance"
                                        class="form-control pull-right datepicker"
                                        id="dob">
                          </masked-input>
                        </div>
                        <div class="form-group">
                          <label for="num_licence">Numero de licence:</label>
                          <input class="form-control" type="text" v-model="searchMembre.num_licence" id="num_licence">
                        </div>
                        <div class="form-group">
                          <a class="btn btn-default pull-left" @click.prevent="choixInscription=null"> < Retour</a>
                          <a @click.prevent="recherche()" class="btn btn-primary  pull-right">Rechercher</a>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 col-md-offset-2">
                      <div class="form-group">
                        <div class="radio"
                             v-for="membre in membresRecherches">
                          <label style="font-weight: 400;"
                                 :class="{'text-red':membre.cantBeSelect, 'text-yellow':isAlreadyInCart(membre.id)}">
                            <input type="radio"
                                   v-model="choixMembreRenouvellement"
                                   :value="membre"
                                   :disabled="membre.cantBeSelect || isAlreadyInCart(membre.id)">
                            {{ membre.fullName }}
                            <i class="fa fa-info-circle"
                               v-if="membre.cantBeSelect && !isAlreadyInCart(membre.id)"
                               v-tooltip.top-center="`Ce membre ne peut pas être renouvellé en ligne. Il est peut-être actuellement licencié dans un autre club ou la date de fin de sa dernière licence active date de plus de 365 jours. Cette licence nécessite une intervention du secrétariat pour son renouvellement.`">
                            </i>
                            <i class="fa fa-info-circle"
                               v-if="!membre.cantBeSelect && isAlreadyInCart(membre.id)"
                               v-tooltip.top-center="`Ce membre est déjà dans votre panier.`">
                            </i>
                          </label>
                        </div>
                      </div>
                      <div class="form-group">
                        <a class="btn btn-primary pull-left" v-if="choixMembreRenouvellement"
                           @click.prevent="addToCartClubFct()"> Ajouter cette licence au panier</a>
                      </div>
                    </div>
                  </div>

                </b-card>
              </b-collapse>

            </div>

            <div class="col-md-6">

            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script type="text/babel">
  import Auth from '@/auth'
  import moment from 'moment/moment'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    props: {},
    data() {
      return {
        choixInscription: null,
        newMembre: this.clearNewMembre(),
        rechercheEnCours: false,
        membresRecherches: [
          // {id: 2, fullName: "Coucou2"},
          // {id: 3, fullName: "Coucou3"},
          // {id: 4, fullName: "Coucou4"},
        ],
        choixMembreRenouvellement: null,
        searchMembre: {
          date_naissance: process.env.NODE_ENV == 'development' ? "23/01/1970" : "",
          num_licence: process.env.NODE_ENV == 'development' ? "10602" : "",
        },
        stepText: "Choix du type d'inscription",
        showCollapse1: true,
        showCollapse2: false
      }
    },
    methods: {
      ...mapActions({
        addToCart: 'addToCart'
      }),
      isAlreadyInCart: function (id) {
        // return "bonjour"
        // return this.getCart
        return _.has(this.getCart, 'licence_renew')
          && _.has(this.getCart.licence_renew, id)
      },
      resetForm: function () {
        this.clearNewMembre();
        this.choixInscription = null
        this.rechercheEnCours = false
        this.membresRecherches = []
        this.choixMembreRenouvellement = null
        this.searchMembre = {
          date_naissance: "",
          num_licence: "",
          renew: true
        }
      },
      clearNewMembre: function () {
        return {
          nom: "",
          prenom: "",
          sexe: 1,
          date_naissance: "01/01/1970",
          adresse: "",
          cp: "",
          ville: "",
          telephone_gsm: "",
          email: ""
        }
      },
      addToCartClubFct() {
        if (this.choixInscription == "renew") {
          let product = {
            type: 'licence_renew',
            membre: this.choixMembreRenouvellement,
            quantity: 1
          }
          this.addToCart(product)
        }
        this.$noty.success("La licence a été ajoutée à votre panier")
        this.resetForm();
      },
      recherche: function () {
        let these = this
        this.rechercheEnCours = true
        this.membresRecherches = []
        this.choixMembreRenouvellement=null
        return this.$http.post(process.env.API_URL + "getMemberForRenew",
          JSON.stringify({
            "id_club": these.getClub.id,
            "date_naissance": these.searchMembre.date_naissance,
            "numero_licence": these.searchMembre.num_licence
          })
        ).then(function (response) {
          these.rechercheEnCours = false
          these.membresRecherches = response.body;
        }, (response) => {
          these.$noty.error("Erreur dans la requête")
          these.rechercheEnCours = false
        })
      },
      currentYear: function () {
        return moment().year();
      },

    },
    components: {},
    watch: {
      'choixInscription': function (value) {
        switch (value) {
          case null:
            this.stepText = "Choix du type d'inscription";
            this.showCollapse1 = true
            this.showCollapse2 = false
            break;
          case 'new':
            this.stepText = "Inscription d'un nouveau membre";
            this.showCollapse1 = false
            this.showCollapse2 = true
            break;
          case 'renew':
            this.stepText = "Renouvellement d'un membre";
            this.showCollapse1 = false
            this.showCollapse2 = true
            break;
        }
      }
    },
    computed: {
      ...mapGetters({
        getClub: 'getClub',
        getRoutes: 'getRoutes',
        getCart: 'getCart',
      }),

    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Club/Inscriptions/Inscriptions.vue